module.exports = __webpack_public_path__ + "static/media/designer.eb0659a8.png";